import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi, type AuthUser } from '../../api/auth';

export function SecurityDashboardPage() {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void authApi.me().then(setUser).catch((err) => setError(err instanceof Error ? err.message : 'Failed to load profile'));
  }, []);

  return (
    <div className="mx-auto max-w-3xl p-6">
      <h1 className="text-2xl font-semibold text-slate-900">Security dashboard</h1>
      <p className="mt-1 text-sm text-slate-600">Manage authentication, sessions, and account security.</p>
      {error && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
      {user && (
        <dl className="mt-6 rounded-xl border border-slate-200 bg-white p-4 text-sm">
          <div className="grid gap-2">
            <div><dt className="text-slate-500">Email</dt><dd>{user.email}</dd></div>
            <div><dt className="text-slate-500">Email verified</dt><dd>{user.email_verified ? 'Yes' : 'No'}</dd></div>
            <div><dt className="text-slate-500">Account status</dt><dd>{user.status}</dd></div>
          </div>
        </dl>
      )}
      <nav className="mt-6 grid gap-3 sm:grid-cols-2">
        <Link to="/account/change-password" className="rounded-xl border border-slate-200 bg-white p-4 hover:border-slate-400">
          <p className="font-medium text-slate-900">Change password</p>
          <p className="mt-1 text-sm text-slate-600">Update your password and sign out other sessions.</p>
        </Link>
        <Link to="/account/sessions" className="rounded-xl border border-slate-200 bg-white p-4 hover:border-slate-400">
          <p className="font-medium text-slate-900">Active sessions</p>
          <p className="mt-1 text-sm text-slate-600">Review and revoke signed-in devices.</p>
        </Link>
        <Link to="/account/trusted-devices" className="rounded-xl border border-slate-200 bg-white p-4 hover:border-slate-400">
          <p className="font-medium text-slate-900">Trusted devices</p>
          <p className="mt-1 text-sm text-slate-600">Manage devices saved with Remember me.</p>
        </Link>
        <Link to="/verify-email" className="rounded-xl border border-slate-200 bg-white p-4 hover:border-slate-400">
          <p className="font-medium text-slate-900">Verify email</p>
          <p className="mt-1 text-sm text-slate-600">Confirm your email address with a verification token.</p>
        </Link>
      </nav>
    </div>
  );
}
